export const LIVE_CHAT_ENABLE_MUTATION_CACHE_KEY = "live-chat-enable";
